// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mind-body-shield-immune.svg';

export const MindBodyShieldImmune = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
